import {priority} from '@priority-software/priority-proto-api/lib';
import {Field} from './Field';
import {Form} from './Form';
import {getUuid4} from '../../utils/getUuid4';

export class Record {
    recordIndex: number;
    parentForm: Form;
    fieldsMap: Map<number, Field> = new Map<number, Field>();
    isNew: boolean;
    // stays for the current session updates
    isRecent: boolean;
    isTemporary: boolean = false;
    private _key: string = ''; // client key. It uses for the client side reconciliation and field Value update mode (react usage);
    properties: priority.netitems.form.IRecord;

    constructor(
        form: Form,
        properties: priority.netitems.form.IRecord,
        recordIndex: number,
        isNew: boolean = false,
        isTemporary: boolean = false
    ) {
        this.parentForm = form;
        this.recordIndex = recordIndex;
        this.isNew = isNew;
        this.isTemporary = isTemporary;
        this.properties = properties;
        this.setFields(properties.Fields);
    }

    get fields(): Field[] {
        return [...this.fieldsMap.values()];
    }

    get clientKey() {
        return this._key;
    }

    // Keys - value related backend data.
    get keys(): Array<priority.netitems.form.IField> {
        const keys = this.parentForm.keyColumns
            .map(c => {
                const field = this.getField(Number(c.ID));
                return field?.Value ? {Value: field.Value, ColumnID: field.columnId} : null;
            })
            .filter(Boolean);
        return !!keys.length ? keys : null;
    }

    setFields(fields: priority.netitems.form.IField[] | null) {
        this._key = getUuid4();

        fields?.forEach(field =>
            this.fieldsMap.set(
                Number(field.ColumnID),
                new Field(this.parentForm.columnsMap.get(Number(field.ColumnID)), field)
            )
        );
    }

    isEmpty = () => {
        return !this.fields.find(f => f.currentValue);
    };

    getField = (columnId: number): Field => {
        return this.fieldsMap.get(columnId);
    };

    setRecordIndex = (recordIndex: number) => {
        this.recordIndex = recordIndex;
    };

    // Get the company value for the record (in multi-company forms)
    // or fall back to the form's dname
    getRecordCompany = () => {
        const compNameColumn = this.parentForm.columns.find(c => c.MultiEnv);
        const compValue =
            this.parentForm.isMultiComp && compNameColumn
                ? this.getField(compNameColumn.id).currentValue
                : this.parentForm.dname;

        return compValue;
    };
}
